<template>
  <!--新增文档分类-->
  <addCategory></addCategory>
</template>

<script>
import addCategory from '@/components/package/addCategory.vue';
export default {
  components: {
    addCategory: addCategory
  },
  name: 'addDocCate'
};
</script>
